import React from "react"

export default ({ testimonial, person }) => (
  <div className="testimonial-card">
    <blockquote>{testimonial}</blockquote>
    <aside>{person}</aside>
  </div>
)
